import { render, staticRenderFns } from "./DisciplineType.vue?vue&type=template&id=62c3bab4"
import script from "./DisciplineType.vue?vue&type=script&lang=js"
export * from "./DisciplineType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c3bab4')) {
      api.createRecord('62c3bab4', component.options)
    } else {
      api.reload('62c3bab4', component.options)
    }
    module.hot.accept("./DisciplineType.vue?vue&type=template&id=62c3bab4", function () {
      api.rerender('62c3bab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/DisciplineType.vue"
export default component.exports